<template>
    <div class="canvas">
        <div class="canvas-out mt-30">
            <div v-for="item, index in list" :key="index"  class="canvas-out-for b-b-ds">
                <el-row class="list fixed mt-20" :gutter="15">
                    <el-col class="item-left" :span="3" :xs="3">
                        <div class="year fs15">{{item.showDate?item.showDate.substring(0, 10):''}}</div>
                    </el-col>
                    <div @click="handleDetail(item.docId)" style="cursor:pointer">
                        <el-col class="item-text b-l-sl" :span="18" :xs="18">
                            <div class="text-name fs20 line1 pl-15">{{item.title}}</div>
                            <!-- <div class="text-detail-2 line3 mt-10">{{item.content}} </div> -->
                        </el-col>
                        <el-col :span="3" :xs="3">
                            <div class="detail-button">查看详情>></div>
                        </el-col>
                    </div>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'info-list',
    props:{
        list:[]
    },
    data () {
        return {}
    },
    methods: {
        handleDetail(val){
            this.$emit('handleDetail', val)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './InfoList.scss'

</style>
